import React from 'react'

import Particles from "react-particles-js"

import "./style.css"

function ParticlesBackround({amount}) {
    return (
        <Particles
        className="particles__bg__container"
        params={
            {
            "particles": {
                "number": {
                    "value": amount ? amount : 100,
                    "density": {
                        "enable": false
                    }
                },
                "size": {
                    "value": 4,
                    "random": true
                },
                "move": {
                    "direction": "bottom",
                    "out_mode": "out"
                },
                "line_linked": {
                    "enable": false
                },
                color: '#000'
            
            },
            "interactivity": {
                // "events": {
                //     "onclick": {
                //         "enable": true,
                //         "mode": "remove"
                //     }
                // },
                "modes": {
                    "remove": {
                        "particles_nb": 10
                    }
                }
            }
        }} />
    )
}
export default ParticlesBackround
